import Box from '@mui/material/Box';
import type { FC } from 'react';
import { NAVY, YELLOW } from 'styles/tokens';

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  stroke?: string;
  accent?: string;
}

const Sparkline: FC<SparklineProps> = ({ values, width = 120, height = 32, stroke = NAVY, accent = YELLOW }) => {
  if (!values || values.length === 0) {
    return <Box sx={{ width, height }} />;
  }

  const padding = 2;
  const innerW = width - padding * 2;
  const innerH = height - padding * 2;

  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;

  const points = values.map((v, i) => {
    const x = padding + (i / Math.max(values.length - 1, 1)) * innerW;
    const y = padding + innerH - ((v - min) / range) * innerH;
    return [x, y] as const;
  });

  const path = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)}`).join(' ');
  const [lastX, lastY] = points[points.length - 1];

  return (
    <Box sx={{ display: 'inline-flex', lineHeight: 0 }}>
      <svg width={width} height={height} role="img" aria-label="Tendencia">
        <title>Tendencia</title>
        <path d={path} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
        <circle cx={lastX} cy={lastY} r={3} fill={accent} />
      </svg>
    </Box>
  );
};

export default Sparkline;
